import { Button } from '../../components/Button';
import { ContentParser } from '../../components/ContentParser';
import { Divider } from '../../components/Divider';
import { NotificationBox } from '../../components/NotificationBox';
import { PageHeading } from '../../components/PageHeading';
import { PanelCard } from '../../components/PanelCard';
import { TimeslotChipSelector } from '../../components/TimeslotChipSelector';
import { ReservationPanel } from '../ReservationPanel';
import { Container } from './BookingNotificationContent.styles';
import type { BookingNotificationContentProps } from './BookingNotificationContent.types';

export function BookingNotificationContent(props: BookingNotificationContentProps) {
  const { title, subtitle, variant, notificationLabels } = props;

  return (
    <Container>
      <PageHeading title={title} subtitle={subtitle} />
      {variant === 'telephoneOnly' && (
        <NotificationBox
          title={notificationLabels.title}
          subtitle={<ContentParser text={notificationLabels.subtitle} />}
        />
      )}
      {variant === 'unavailable' && (
        <>
          <PanelCard>
            <ReservationPanel {...props.reservationProps} />
            {props.arrivalTimeProps && props.arrivalTimeProps.timeslots.length > 0 && (
              <>
                <Divider />
                <TimeslotChipSelector {...props.arrivalTimeProps} />
              </>
            )}
          </PanelCard>
          <NotificationBox
            title={notificationLabels.title}
            subtitle={<ContentParser text={notificationLabels.subtitle} />}
            cta={
              notificationLabels.ctaLabel ? (
                <Button variant="primary" onClick={notificationLabels.onCtaClick}>
                  {notificationLabels.ctaLabel}
                </Button>
              ) : undefined
            }
          />
        </>
      )}
    </Container>
  );
}
